import axios from "axios";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useLocation, useParams } from "react-router-dom";
import Config from "../../Config";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import moment from "moment";
import {
  FieldWrapper,
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import Loading from "../../Components/Loading";
import { useTranslation } from "react-i18next";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import Navbar from "../../Components/Navbar";
import Table from "../../Components/ActiveLogs/Table";

const ActiveLogs=()=>{
    const{ id } = useParams();
    const user = useSelector((state) => state.UserReducer.user);
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const [filterValue, setFilterValue] = useState("");
    const [filter, setFilter] = useState("mobile");
    const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(15, "days").format("YYYY-MM-DD")
    );
    const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
    );

    const initialValues = {
    name: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(30, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
    };
    

    const FetchFunction =async()=>{
        const body = new FormData();
        body.append("clientId",id);
        body.append("startDate", startDate);
        body.append("endDate", endDate);
        body.append("filterType", filter);
        body.append("filterValue", filterValue);
        return await axios.post(`${Config.apiUrl}/getactivitylogs`, body,{
            headers : {
                authorization: "Bearer " + user.token,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            }
        })
    }
    const {
        isLoading: isLoading,
        mutate: getActiveLogMutate,
        error,
        data,
        isRefetching,
      } = useMutation(FetchFunction, {});
    
        useEffect(() => {
          const handler = setTimeout(() => {
            getActiveLogMutate();
          }, 500);
      
          return () => {
            clearTimeout(handler);
          };
        }, [filterValue, startDate, endDate]);

        const submitHandler = (values) => {
        const newValues = {
            startDate: moment(values.startDate).format("YYYY-MM-DD"),
            endDate: moment(values.endDate).format("YYYY-MM-DD"),
        };
        setStartDate(newValues.startDate);
        setEndDate(newValues.endDate);
        getActiveLogMutate();
        };
        const ChangeHandler = (e) => {
        setFilterValue(e.target.value);
        };
    
    return(
        <>
          <Bg
                style={{
                backgroundImage: `url(${Images.BeamsBg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "top left",
                height: "100vh",
                }}
            >
            <Navbar />
    
            <BoxContainer>
                <div className="flex w-full justify-between items-center">
                    <div>
                    <Title>
                        {t("Active Logs")}
                        <span>{location?.state?.name}</span>
                    </Title>
                    <Underline />
                    </div>
                </div>

                <div className="flex w-full justify-between items-center">
                    <Filters
                        submitHandler={submitHandler}
                        initialValues={initialValues}
                        InitialLoading={isLoading}
                        setFilter={setFilter}
                        setFilterValue={setFilterValue}
                        ChangeHandler={ChangeHandler}
                        filterValue={filterValue}
                        filter={filter}
                        t={t}
                        />
                </div>
        
                {!error && !isLoading && data && (
                    <TableWrapper>
                    <Table
                        // ApiData={error ? [] : data?.data?.data}
                        ApiData={error ? []:
                        Array.isArray(data?.data?.data)
                            ? data.data.data
                            : data?.data?.data
                            ? [data.data.data]   // wrap object into array
                            : []
                        }
                        userType={user.userType}
                    />
                    {(error || data?.data?.msg == "No data found") && !isLoading && (
                        <NotFoundModel />
                    )}
                    </TableWrapper>
                )}
                {(isLoading || isRefetching) && <Loading />}
            </BoxContainer>
            </Bg>
        </>
    )
}

    const Filters = ({
    initialValues,
    submitHandler,
    InitialLoading,
    t,
    }) => {
    const today = moment().format("YYYY-MM-DD");
    return (
        <Formik initialValues={initialValues} onSubmit={submitHandler}>
        <Form className="w-full">
            <FilterContainer>
            <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
                <div className="flex items-end gap-2">
                <InputGroup className="max-w-[130px]">
                    <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                    <FieldWrapper className="h-10">
                    <img
                        src={Images.Calender}
                        alt="Calender icon"
                        className="w-3.5"
                    />
                    <Field
                        type="date"
                        name="startDate"
                        id="startDate"
                        className="ml-1"
                        max={today}
                    />
                    </FieldWrapper>
                </InputGroup>

                <InputGroup className="max-w-[130px]">
                    <Label htmlFor="endDate">{t("End_Date")}:</Label>
                    <FieldWrapper className="h-10">
                    <img
                        src={Images.Calender}
                        alt="Calender icon"
                        className="w-3.5"
                    />
                    <Field
                        type="date"
                        name="endDate"
                        id="endDate"
                        className="ml-1"
                        max={today}
                    />
                    </FieldWrapper>
                </InputGroup>
                </div>
                <ApplyBtn disabled={InitialLoading} type="submit">
                {t("Date_filter")}
                </ApplyBtn>
            </div>
            </FilterContainer>
        </Form>
        </Formik>
    );
    };

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md`;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;

const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;

export default ActiveLogs;